
import Clarity from '@microsoft/clarity';
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CLARITY_PROJECT_ID } from '../../../project_config';
import EditorPageLayout from "../../common/editor/EditorPageLayout";
import Form from "./form/Form";

export default function EpisodeAdd() {
	Clarity.init(CLARITY_PROJECT_ID);
	const [isDesktop, setIsDesktop] = useState(() => window.innerWidth > 768);
	const { workshopId } = useParams();

	useEffect(() => {
		const onResize = () => setIsDesktop(window.innerWidth > 768);
		window.addEventListener("resize", onResize);
		return () => window.removeEventListener("resize", onResize);
	}, []);

	const linkDataList = [
		{ label: 'خانه', href: '/' },
		{ label: 'کارگاه‌ها', href: '/workshop_list/' },
		{ label: 'کارگاه', href: `/workshop_detail/${workshopId}/` },
		{ label: 'افزودن جلسه' },
	];

	return (
		<EditorPageLayout
			isDesktop={isDesktop}
			pageTitle="افزودن جلسه"
			metaDescription="افزودن جلسه جدید به کارگاه در همراهتیم"
			breadcrumbLinks={linkDataList}
		>
			<Form />
		</EditorPageLayout>
	);
}
